import List from "@/modules/hrs/check_ins/views/List"
import { Upsert } from "@/modules/hrs/check_ins/views/Upsert"
import { Route, Routes } from "react-router-dom"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      {/* <Route path="create" element={<Create />} /> */}
      <Route path=":id" element={<Upsert />} />
    </Routes>
  )
}
